module.exports = __webpack_public_path__ + "img/content3-4.c95757c8.webp";